module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 120x200 cm_White.fd9b8b0b.png";